import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/client";

export const useTicketStatuses = (domain) => {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatuses = useCallback(async () => {
    if (!domain) {
      setStatuses([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await apiClient.get(`/api/ticketstatuses?domain=${encodeURIComponent(domain)}`);
      setStatuses(res.data || []);
    } catch (err) {
      console.error("Failed to load ticket statuses:", err);
      setError(err.message || "Failed to load statuses");
      setStatuses([]);
    } finally {
      setLoading(false);
    }
  }, [domain]);

  useEffect(() => {
    fetchStatuses();
  }, [fetchStatuses]);

  return { statuses, loading, error };
};